import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class DefectActionService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

addDefectActions(data: any): Observable<any> {
 // return this.http.post<any>(this.baseUrl + 'adddefectactions', data);
return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/AddDefectActions', data);
}


getDefectActions(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/getAllDefectActions', data);
}

getDefectActions2(data: any): Observable<any> {
  // return this.http.post<any>(this.baseUrl + 'getalldefectactions', data);
  return this.http.post<any[]>(this.O3CoreApiUrl + 'DefectAction/GetDefectActions', data);
}
deleteDefectActions(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/DeleteDefectAction', data);
}

// setNewTargetDates(data: any): Observable<any> {

//   return this.http.post<any>(this.baseUrl + 'defecttargetdate', data);
// }
setNewTargetDates(data: any): Observable<any> {

  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/SetNewTargetDate', data);
}
SetNewTargetDate

setUsersActionsCompleted(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/SetUserActionsCompleted', data);
}

setUsersActionsRejected(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/setUserActionsRejected', data);
}

setUsersActionsVerified(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/setUserActionsVerified', data);
}

setActionRemarks(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/setDefectActionRemarks', data);
}
setGembaActionImage(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DefectAction/DefectActionImage', data);
}
getDepartmentsMachine(data: any): Observable<any> {
  return this.http.post<any>(this.O3CoreApiUrl + 'DMS/GetDepartmentsMachine', data);
}
}
